import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RewardsToTeamsResponse, TournamentRewards } from './types';

export const rewardsApi = createApi({
  reducerPath: 'rewardsApi',
  baseQuery: fetchBaseQuery({ baseUrl: '/api/v1/rewards/' }),
  endpoints: (builder) => ({
    getRewardsByTeams: builder.query<TournamentRewards, number>({
      query: (tournamentId: number) => `teams/?tournament_id=${tournamentId}`,
      transformResponse: (response: RewardsToTeamsResponse, _, tournamentId): TournamentRewards => {
        const rewards = response.data[tournamentId];
        return (rewards && Object.keys(rewards).length)
          ? rewards
          : undefined
      },
    }),
  }),
});

export const {
  useGetRewardsByTeamsQuery,
} = rewardsApi;
